import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getAllBarangays } from '../services/barangayService';

const Header = () => {
  const [isSticky, setIsSticky] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [barangays, setBarangays] = useState([]);
  const [loadingBarangays, setLoadingBarangays] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchBarangays = async () => {
      try {
        setLoadingBarangays(true);
        const data = await getAllBarangays();
        setBarangays(data);
      } catch (error) {
        console.error('Error fetching barangays for dropdown:', error);
      } finally {
        setLoadingBarangays(false);
      }
    };

    fetchBarangays();
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleBarangaySelect = (slug) => {
    navigate(`/${slug}`);
    setIsDropdownOpen(false);
    closeMobileMenu();
  };

  const logoTransform = {
    transform: isMobile ? 'scale(3) translate(-5px, 1px)' : 'scale(3) translateY(2px)',
    transformOrigin: 'left center'
  };

  const logoLinkStyle = {
    display: 'inline-block',
    position: 'relative',
    zIndex: 100,
    padding: isMobile ? '10px 60px 10px 10px' : '10px 80px 10px 10px'
  };

  return (
    <header
      className={`nk-header page-header is-transparent ${isSticky ? 'is-sticky is-shrink' : ''} is-dark`}
      id="header"
    >
      {/* Header Main */}
      <div className="header-main">
        <div className="header-container container">
          <div className="header-wrap">
            {/* Logo */}
            <div className="header-logo logo">
              <Link to="/" className="logo-link" onClick={closeMobileMenu} style={logoLinkStyle}>
                <img className="logo-dark ebarangay-logo" src="/logo.png" alt="EBARANGAY logo" style={logoTransform} />
                <img className="logo-light ebarangay-logo" src="/logo.png" alt="EBARANGAY logo" style={logoTransform} />
              </Link>
            </div>

            {/* Menu Toggle */}
            <div className="header-nav-toggle">
              <button
                type="button"
                className={`navbar-toggle ${isMobileMenuOpen ? 'active' : ''}`}
                onClick={toggleMobileMenu}
                aria-label="Toggle navigation menu"
                style={{
                  background: 'transparent',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer'
                }}
              >
                <div className="toggle-line">
                  <span></span>
                </div>
              </button>
            </div>

            {/* Menu */}
            <div
              className={`header-navbar header-navbar-s1 ${isMobileMenuOpen ? 'mobile-menu-active' : ''}`}
              style={{
                display: isMobileMenuOpen ? 'block' : undefined,
                position: isMobileMenuOpen ? 'fixed' : undefined,
                top: isMobileMenuOpen ? '0' : undefined,
                left: isMobileMenuOpen ? '0' : undefined,
                width: isMobileMenuOpen ? '100%' : undefined,
                height: isMobileMenuOpen ? '100vh' : undefined,
                backgroundColor: isMobileMenuOpen ? '#1a1a2e' : undefined,
                zIndex: isMobileMenuOpen ? '9999' : undefined,
                overflowY: isMobileMenuOpen ? 'auto' : undefined,
                paddingTop: isMobileMenuOpen ? '80px' : undefined
              }}
            >
              <nav className="header-menu" id="main-menu">
                <ul className="menu menu-s2">
                  <li className={`menu-item ${location.pathname === '/' ? 'active' : ''}`}>
                    <Link className="menu-link nav-link" to="/" onClick={closeMobileMenu}>
                      Home
                    </Link>
                  </li>
                  <li className={`menu-item ${location.pathname === '/services' ? 'active' : ''}`}>
                    <Link className="menu-link nav-link" to="/services" onClick={closeMobileMenu}>
                      Barangay Services
                    </Link>
                  </li>
                  <li className={`menu-item ${location.pathname === '/about' ? 'active' : ''}`}>
                    <Link className="menu-link nav-link" to="/about" onClick={closeMobileMenu}>
                      About Us
                    </Link>
                  </li>
                  <li className={`menu-item ${location.pathname === '/contact' ? 'active' : ''}`}>
                    <Link className="menu-link nav-link" to="/contact" onClick={closeMobileMenu}>
                      Contact Us
                    </Link>
                  </li>
                  <li className="menu-item has-sub" style={{ position: 'relative' }}>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      className="menu-link nav-link"
                      href="#"
                      onClick={(e) => { e.preventDefault(); toggleDropdown(); }}
                      style={{ cursor: 'pointer' }}
                    >
                      Barangays
                    </a>
                    {isDropdownOpen && (
                      <ul
                        className="menu-sub"
                        style={{
                          display: 'block',
                          position: isMobileMenuOpen ? 'relative' : 'absolute',
                          top: isMobileMenuOpen ? '0' : '100%',
                          left: isMobileMenuOpen ? '20px' : '0',
                          backgroundColor: '#1a1a2e',
                          minWidth: '200px',
                          padding: '10px 0',
                          borderRadius: '4px',
                          boxShadow: '0 4px 6px rgba(0,0,0,0.3)',
                          zIndex: 1000,
                          maxHeight: '300px',
                          overflowY: 'auto'
                        }}
                      >
                        {loadingBarangays ? (
                          <li style={{ padding: '10px 20px', color: '#fff' }}>Loading...</li>
                        ) : barangays.length > 0 ? (
                          barangays.map((barangay) => (
                            <li key={barangay.id} style={{ margin: '0' }}>
                              <a
                                href={`/${barangay.slug}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleBarangaySelect(barangay.slug);
                                }}
                                style={{
                                  display: 'block',
                                  padding: '8px 20px',
                                  color: '#fff',
                                  textDecoration: 'none',
                                  transition: 'background-color 0.2s'
                                }}
                                onMouseEnter={(e) => e.target.style.backgroundColor = '#e02f29'}
                                onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                              >
                                {barangay.name}
                              </a>
                            </li>
                          ))
                        ) : (
                          <li style={{ padding: '10px 20px', color: '#fff' }}>No barangays available</li>
                        )}
                      </ul>
                    )}
                  </li>
                </ul>
                <ul className="menu-btns">
                  <li>
                    <a
                      href="https://play.google.com/store"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-md btn-grad btn-round"
                    >
                      <span style={{ color: '#ffffff' }}>Download App</span>
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
